<script>
export default {
    props: {
        slice: {
            type: Object,
            required: true
        }
    }
};
</script>